export default "__VITE_ASSET__BMy2WGpD__"